import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import Papa from "papaparse"

function OfferSponsors(props) {
	const { t } = useTranslation();
	const [organizer, setOrganizer] = useState('');
	const [coOrganizer, setCoOrganizer] = useState('')
	const [cooperation, setCooperation] = useState('');
	const [support, setSupport] = useState('');
	const [specialCoOperation, setSpecialCoOperation] = useState('');
	const [subsidized, setSubsidized] = useState('');
	//FY26用文字段落を特殊に変更
	const [langFlag, setlangFlag] = useState('');
	const [supportFlag, setSupportFlag] = useState('');
	const [organizerFlag, setOrganizerFlag] = useState('');
	const [cooperationFlag, setCooperationFlag] = useState('');

	useEffect(() => {
		if(props) {
			setOfferSponsors();
		}
	});

	const setOfferSponsors = () => {
		if (props) {
			if (props.language === 'ja_JP') {
				setOrganizer(props.organizer);
				setCoOrganizer(props.co_organizer);
				setCooperation(props.cooperation);
				setSupport(props.support);
				setSpecialCoOperation(props.special_co_operation);
				setSubsidized(props.subsidize);
				setlangFlag(false);
				setSupportFlag(false);
				setOrganizerFlag(false);
				setCooperationFlag(false);
				if(cooperation) {
					if (cooperation.indexOf(',"') >= 0) {
						setCooperationFlag(true)
					}
				}
			}
			else {
				setOrganizer( props.organizer_en);
				setCoOrganizer(props.co_organizer_en);
				setCooperation(props.cooperation_en);
				setSupport(props.support_en);
				setSpecialCoOperation(props.special_co_operation_en);
				setSubsidized(props.subsidize_en);
				setlangFlag(true);
				setSupportFlag(false);
				setOrganizerFlag(false);
				setCooperationFlag(false);
				
				if(support) {
					if (support.indexOf(',"') >= 0) {
						setSupportFlag(true)
					}
				}
				if(organizer) {
					if (organizer.indexOf(',"') >= 0) {
						setOrganizerFlag(true)
					}
				}
				if(cooperation) {
					if (cooperation.indexOf(',"') >= 0) {
						setCooperationFlag(true)
					}
				}
			}
		}
	}
	
	return (
		
		<div className="detail-body__sponsors">
			{organizer && !organizerFlag && (
				<p>{parseProgram(t('offer.sponsors.organizer') + '：' + organizer)}</p>
			)}
			{organizer && organizerFlag && (
				<p>{parseProgram(t('offer.sponsors.organizer') + '：' + organizer, t('offer.sponsors.organizer') + '：')}</p>
			)}
			{coOrganizer && (
				<p>{t('offer.sponsors.coOrganizer')}{'：'}{coOrganizer}</p>
			)}
			{/* ",がある場合はこちらで処理 */}
			{support && !supportFlag && (
				<p>{parseProgram(t('offer.sponsors.support') + '：' + support)}</p>
			)}
			{support && supportFlag && (
				<p>{parseProgram(t('offer.sponsors.support') + '：' + support , t('offer.sponsors.support') + '：')}</p>
			)}
			{/* ",がある場合はこちらで処理 */}
			{cooperation && !cooperationFlag && (
				<p>{t('offer.sponsors.cooperation') + '：' + cooperation}</p>
			)}
			{cooperation && cooperationFlag && (
				<p>{parseProgram(t('offer.sponsors.cooperation') + '：' + cooperation, t('offer.sponsors.cooperation') + '：')}</p>
			)}
			{/* 協力・助成は特殊--- */}
			{specialCoOperation && langFlag && (
				<p>{parseProgram(t('offer.sponsors.specialCoOperation') +'：' + specialCoOperation, t('offer.sponsors.specialCoOperation') +'：' )}</p>
			)}
			{specialCoOperation && !langFlag && (
				<p>{parseProgram(t('offer.sponsors.specialCoOperation') +'：' + specialCoOperation)}</p>
			)}
			{/* 協力・助成は特殊--- */}
			{subsidized && (
				<p>{t('offer.sponsors.subsidize')}{'：'}{subsidized}</p>
			)}
			{props.support_logo_url && (
				<a href={props.support_url}><img src={props.support_logo_url} width="90" height="94" alt={props.support} /></a>
			)}
			{props.special_co_operation_logo_url && (
				<img src={props.special_co_operation_logo_url} width="90" height="94" alt={props.special_co_operation} />
			)}
		</div>
		
	);
}

const parseProgram = (text, prefixText) => {
  if (text !== undefined) {
	let description = Papa.parse(text)
	if (description !== undefined) {
	  return (
		<>
		  {description.data[0].map((item, index) => {
			if (prefixText != ""){
				return (index == 0) ? <p key={index}> {item} </p> : <p style={{visibility:"hidden"}} key={index}>{prefixText}<span style={{ visibility:"visible" }}>{item}</span></p> ;
			}
			else {
				return <p key={index}> {item} </p>
			}
		  })}
		</>
	  )
	}
  }
}

export default OfferSponsors;
